module.exports = __webpack_public_path__ + "static/charles-wallace-thomas-1b34bdb37ff8a6e8d242da8894b4492b.jpg";